import { IncidentTypeItem } from '@/server/services/GoogleBigQuery/BigQueryIncidentsClient.types';
import { Colors } from '@/styles/colors';
import { ColorHex } from '@/types';

/** Equal to COLORS_PALETTE length */
export type IncidentTypeIdColor =
  | '1'
  | '2'
  | '3'
  | '4'
  | '5'
  | '6'
  | '7'
  | '8'
  | '9'
  | '10'
  | '11'
  | '12'
  | '13'
  | '14'
  | '15'
  | '16'
  | '17'
  | '18'
  | '19'
  | '20'
  | '21'
  | '22'
  | '23'
  | '24'
  | '25';

export const COLORS_PALETTE: Array<ColorHex> = [
  '#2196F3',
  '#18FFFF',
  '#76FF03',
  '#FFFF00',
  '#FF5722',

  '#FF4081',
  '#7E57C2',
  '#FF8A80',
  '#9C27B0',
  '#D7CCC8',

  '#8C9EFF',
  '#009688',
  '#5C6BC0',
  '#00BCD4',
  '#00E676',

  '#FFE082',
  '#FF8F00',
  '#E91E63',
  '#B388FF',
  '#D32F2F',

  '#9E9D24',
  '#795548',
  '#607D8B',
  '#80D8FF',
  '#388E3C',
];

/**
 * Map of incident type IDs to colors.
 * @returns {'1': '#67b26d', '2': '#fcd752', ...}
 */
export const INCIDENT_TYPE_COLOR: Record<IncidentTypeIdColor, ColorHex> = COLORS_PALETTE.reduce(
  (acc, color, index) => {
    const id = String(index + 1) as IncidentTypeIdColor;
    acc[id] = color;
    return acc;
  },
  {} as Record<IncidentTypeIdColor, ColorHex>,
);

export const getIncidentTypeIds = () => [...Object.keys(INCIDENT_TYPE_COLOR)] as IncidentTypeIdColor[];

export const getIncidentTypeIdColors = () => [...Object.values(INCIDENT_TYPE_COLOR)] as ColorHex[];

/** @deprecated */
export const getIncidentTypeIdColor = (typeId: IncidentTypeItem['IncidentTypeCategory'] | IncidentTypeIdColor) => {
  const rootTypeId = String(parseInt(typeId)) as IncidentTypeIdColor;
  return INCIDENT_TYPE_COLOR[rootTypeId] || Colors.White;
};
